<!-- directory-image.component.html -->
<div class="directory-tree">

    <i class="fa-solid fa-folder-closed" *ngIf="dirSelected?.id>0 else openRoot" (click)="selected(null)"></i>
    <ng-template #openRoot><i class="fa-regular fa-folder-open  text-warning"></i></ng-template>
    
     Raíz <button class="btn" (click)="openModalAdd(add,null)">
        <i class="fa-solid fa-plus"></i>
    </button>
    <ul>
        <ng-container *ngFor="let directory of directories">
            <li>
                <ng-container *ngIf="!directory.isEditing; else editMode">
                    <div (click)="selected(directory)" (contextmenu)="onRightClick($event, directory)" (dblclick)="enableEditMode(directory)">
                        <i [class]="getIconClass(directory)"></i> {{
                        directory.tag }}</div>
                </ng-container>
                <ng-template #editMode>
                    <input class="form-control-minimal" type="text" [(ngModel)]="directory.tag"
                        (blur)="disableEditMode(directory)" (keyup.enter)="disableEditMode(directory)" />
                </ng-template>
                <ul *ngIf="directory.subdirectories?.length > 0">
                    <ng-container
                        *ngTemplateOutlet="recursiveList; context: { $implicit: directory.subdirectories }"></ng-container>
                </ul>
            </li>
        </ng-container>
    </ul>
    <!-- Agregar el componente de menú contextual -->
    <app-context-menu *ngIf="contextMenuVisible" [allDirectories]="allDirectories" (onMouseLeave)="contextMenuVisible=!$event"
        [contextMenuPosition]="contextMenuPosition" [contextMenuDirectory]="contextMenuDirectory"
        (onClickDelete)="openModalDel(del,$event)" (onClickRename)="enableEditMode($event)" (onClickAdd)="openModalAdd(add,$event)"></app-context-menu>

    <ng-template #recursiveList let-directories>
        <li *ngFor="let subdirectory of directories">
            <ng-container *ngIf="!subdirectory.isEditing; else editMode">
                <span (click)="selected(subdirectory)" (contextmenu)="onRightClick($event, subdirectory)" (dblclick)="enableEditMode(subdirectory)">
                    <i [class]="getIconClass(subdirectory)"></i> {{ subdirectory.tag }}</span>
            </ng-container>
            <ng-template #editMode>
                <input class="form-control-minimal" type="text" [(ngModel)]="subdirectory.tag"
                    (blur)="disableEditMode(subdirectory)" (keyup.enter)="disableEditMode(subdirectory)" />
            </ng-template>
            <ul *ngIf="subdirectory.subdirectories?.length > 0">
                <ng-container
                    *ngTemplateOutlet="recursiveList; context: { $implicit: subdirectory.subdirectories }"></ng-container>
            </ul>
        </li>
    </ng-template>
</div>
<ng-template #add let-c="close" let-d="dismiss">
    <form class="form" [formGroup]="form" (ngSubmit)="create()">
        <div class="modal-header">
            <h6>Nuevo directorio</h6>
            <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    <input type="text" id="tag" class="form-control" placeholder="Ingrese el nombre"
                        formControlName="tag" />
                </div>
            </div>
        </div>
        <div class="body-footer">
            <div class="row">
                <div class="col-md-12">
                    <button type="submit" class="btn btn-primary m-2 float-end">Guardar</button>
                </div>
            </div>
        </div>
    </form>
</ng-template>
<ng-template #del let-c="close" let-d="dismiss">
    <form class="form" [formGroup]="form" (ngSubmit)="deleteDirectory()">
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    ¿Esta seguro que desea eliminar este directorio?
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="row">
                <div class="col-md-12">
                    <div class="btn-group">
                        <button type="button" (click)="d('Cross click')" class="btn btn-secondary">No</button>
                        <button type="submit" class="btn btn-danger w-50">Eliminar</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</ng-template>